import { canUseDOM } from '.';
import { noImageUrl } from '../config';

const webpSuffix = '.as.webp';
let support: boolean;

/**
 * Check browser webp support
 * @returns {boolean}
 */
// based on https://github.com/DonRai/react-image-webp/blob/master/modules/utils/index.js
// and on https://stackoverflow.com/questions/5573096/detecting-webp-support
export const isWebpSupported = (): boolean => {
    // V SSR použij webp
    if (('undefined' !== typeof (global as any).SSR) && (true === (global as any).SSR)) {
        return true;
      }

    if (typeof support !== 'undefined') {
        return support;
    }

    if (canUseDOM()) {
        if (('object' === typeof document) && (document as any).createElement) {
            const elem = ('object' === typeof document) ? (document as any).createElement('canvas') : {};
            
            support = (elem as any).toDataURL && ((elem as any).toDataURL('image/webp').indexOf('data:image/webp') === 0);
        } else {
            // Sometimes `TypeError: document.createElement is not a function` error appear in built code
            // Temporary solution for when .createElement() is not a function
            return true;
        }
    } else {
        support = false;
    }
    
    return support;
};

export const addWebpSuffixIfSupported = (fileName: string): string => {

    if (noImageUrl === fileName) {
        return fileName;
    }

    if (isWebpSupported()) {
        return fileName + webpSuffix;
    }

    return fileName;
};


// WEBPACK FOOTER //
// ./src/utils/webP.ts